import { useSelector } from "react-redux";
import { icons } from "../../../assets";
import { CustomMenu } from "../../../components";
import { TrainingMenuList } from "../../common/TrainingMenuList";

const menuItemElemen = [
    { imgHover: icons.dashboardBlue, imgRed: icons.dashboardRed, img: icons.dasboardIcon, text: "Dashboard", viewId: 1, goTo: 'dashboard' },
    // { imgHover: icons.tableBlue, img: icons.table, text: "Tabla de registro", viewId: 3, goTo: "users" },
    { imgHover: icons.tableBlue, imgRed: icons.usersRed, img: icons.table, text: "Usuarios", viewId: 2, goTo: "table" },
    { imgHover: icons.analiticsBlue, img: icons.analytics, text: "Analíticas", viewId: 4, goTo: "analytics" },
    { imgHover: icons.helpIcon, imgRed: icons.helpRed, img: icons.helpWhite, text: "Ayuda", viewId: 5, goTo: "help" },
];

const Menu = () => {

    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    //  if (proyectSelected._id === "672e4328031ac03e79f58508") {
    const Items = menuItemElemen.map((item) => {
        if ((proyectSelected._id === "66155e601e91fe7bde671941" || proyectSelected._id === "672e4328031ac03e79f58508" || proyectSelected._id === "679965563ed6fed031d3b488") && item.viewId === 4) {

            return;
        }
        else {
            const { img, text, viewId, goTo, imgHover, imgRed } = item;
            let imgEfasis = imgHover
            if (proyectSelected._id === "679965563ed6fed031d3b488") {
                imgEfasis = imgRed
            }
            return <TrainingMenuList.Item proyectSelected={proyectSelected._id} key={viewId} imgHover={imgEfasis} img={img} text={text} viewId={viewId} goTo={goTo} />;

        }
    });
    return (
        <CustomMenu>
            <TrainingMenuList>{Items}</TrainingMenuList>
        </CustomMenu>
    );
};

export default Menu;
